import { Injectable,  } from '@angular/core';
import { ToastController, AlertController } from '@ionic/angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({  providedIn: 'root'})
export class GlobalsService {

MSGS_STATE_UNREAD = 1;
MSGS_STATE_READ = 2;
MSGS_STATE_DELETED = 3;
// MSGS_STATE_DELETED_PERMANENT = 4;

MSGS_TYPE_OUT_PSTN_CONV_REC = 1;
MSGS_TYPE_IN_PSTN_CONV_REC = 2;
MSGS_TYPE_VOICEMAIL = 3;
MSGS_TYPE_GREETING = 4;
//  MSGS_TYPE_SENT_PENDING = 5;
MSGS_TYPE_SENT = 6;
//  MSGS_TYPE_CUSTOME_FILE = 7;
//  MSGS_TYPE_CONV_REC_VIRTUAL = 8;
//  MSGS_TYPE_CALLS = 9;
//  MSGS_TYPE_REPORTS = 10;
//  MSGS_TYPE_USAGE = 1000;

MSGS_FORMAT_ANY = 0
MSGS_FORMAT_WAV = 1;
MSGS_FORMAT_MP3 = 2;
MSGS_FORMAT_TIF = 3;
MSGS_FORMAT_PDF = 4;
MSGS_FORMAT_TIF_PDF = 5;
MSGS_FORMAT_TXT = 6;

MSGS_FLAGS_URGENT = 1 << 1;
MSGS_FLAGS_DUPLICATE = 1 << 2;
MSGS_FLAGS_SCREEN_NAME = 1 << 3;
MSGS_FLAGS_FLAGGED = 1 << 4;

CDRS_TYPE_PSTN_IN = 1;
CDRS_TYPE_PSTN_OUT = 2;
// CDRS_TYPE_INTERCOM_IN = 3;
// CDRS_TYPE_INTERCOM_OUT = 4;
CDRS_TYPE_FAX_IN = 5;

PROFILE_FLAG_BUSINESS = 1 << 1;   //  1);
PROFILE_FLAG_PERSONAL = 1 << 2;   //  2);
PROFILE_FLAG_G1 = 1 << 3;   //  4);
PROFILE_FLAG_G2 = 1 << 4;   //  8);
PROFILE_FLAG_G3 = 1 << 5;   //  10);
PROFILE_FLAG_G4 = 1 << 6;   //  20);
PROFILE_FLAG_BLOCKED = 1 << 7;   //  40);
PROFILE_FLAG_FAX = 1 << 8;   //  80);
PROFILE_FLAG_ROUT = 1 << 9;   //  100);  // use profile type as id of table
// PROFILE_FLAG_DELETED = 1 << 10;   
// PROFILE_FLAG_READ = 1 << 11; 
// PROFILE_FLAG_AUTOREAD = 1 << 12; 
// PROFILE_FLAG_SENT = 1 << 14; 
// PROFILE_FLAG_PURGED = 1 << 15; 
// PROFILE_FLAG_HIDDEN = 1 << 16; 
// PROFILE_FLAG_FLAGED = 1 << 17; 

ICO_RECYCL = '/assets/icon/recycled.svg';
ICO_INCALL = '/assets/icon/incall.svg';
ICO_OUTCALL = '/assets/icon/outcall.svg';
ICO_FAX = '/assets/icon/fax.svg';
ICO_HISTORY = '/assets/icon/hist.svg';
ICO_MISSED = '/assets/icon/missedcall.svg';
ICO_REC_CALL = '/assets/icon/reccall.svg';
ICO_FAV = '/assets/icon/refav.ico';

ICO_PERSON = 'person-outline';
ICO_SETTINGS = 'settings-outline';
ICO_SEND = 'send-outline';
ICO_TRASH = 'trash-outline';
ICO_MIC = 'mic-outline';

ICO_RED = 'save-outline';
ICO_DOC = 'document-outline';
ICO_RECORDING = 'recording-outline';
ICO_FLG = 'flag-outline';
ICO_CHAT = 'chatbox-ellipses-outline';
ICO_CHAT_FILL = 'chatbox-ellipses';
ICO_X = 'close-circle-outline';
ICO_STAR = 'medical-outline';
ICO_DOWNLOAD = 'download-outline';
ICO_VOL_LOW = 'volume-low-outline';

ICO_ALERT = 'alert-circle-outline';
ICO_ADD = 'add-circle-outline';
ICO_LOGOUT = 'log-out-outline';
ICO_TIMER = 'timer-outline';

ICO_FILTER = 'filter-outline';
ICO_CALL = 'call-outline';
ICO_NOTIF = 'notifications-outline';
ICO_MAIL = 'mail';
ICO_EMAI_NEW = 'mail-unread-ouline';
ICO_MAIL_OPEN = 'mail-open-outline';
ICO_ARCHIVE = 'archive-outline';
ICO_LOGS = 'receipt-outline';
ICO_BELL = 'notifications-circle-outline';
ICO_BELLOFF = 'notifications-off-outline';
ICO_UP = 'chevron-up-circle-outline';
ICO_RELOAD = 'reload-circle-outline';

p_fix = 'p_fix';
resultRet  = '';
resultRetInt  = 0;

defaultTm = [this.p_fix, "id", "from", "dest", "datetime", "len", "cname", "url", "flags", "state", "format", "type", "body", "custID", "uuid"]
defaultTr = [this.p_fix, "id", "from", "dest", "datetime", "len", "hold", "ring", "cname", "flags", "state", "format", "type", "custID", "uuid"]

GS = new Array();   
GS_tmpl = ['', 1, 1, 0, 0, 0, ''];
  
GS_cap_offset = 0;
// active_Filter = 1;
// only_FilterTag = 2;
// only_filter_id = 3;
GS_se_total_offset = 4;
GS_total_offset = 5;
GS_icon_offset = 6;

user_dataA = new Array(); 
allUsersA = new Array(); 
sipStasions = new Array(); 
smsUserAr = new Array(); 
customRuts = new Array(); 
smsSendA = new Array(); 
uvmGrsA = new Array(); 
refrence = ''; 

pathSelected = -1;
path = '';
upsw = '';  // user entered psw
rpsw = '';  // remember me psw
duuid = '';
suuid = '';
url_prefix = '';
bg = '';

deviceOP = '';
phRecover = '';
emRecover = '';
username = '';
remv = true;

msgsListStat = [0, 0, 0, 0]; // total, visible, deleted
msgsTmpls = new Array();  // list of msgs
ITMS = new Array();  // list of msgs

msgsGTlocalStoreArr = new Array();  // list of LS
msgsGTtmp = new Array();  // list of msgs
LStmpl =     [1, 0, 0, 0, 0, 0, 0, 0, 0, '', '', '', ''];
LStmplTmpl = [1, 1, 0, 0, 0, 0, 0, 0, 0, '', '', '', ''];

isLoaded = 0   //  HARD CODE

typeOffS = 1;   //  type 0=msg 1=tmpl,  // problem ???
isVis = 2;
GT_type_ind = 3;
readOffS = 4;   // readonly
GT_state_ind = 5;
ifItemInSearch = 6;
flags1_offset = 7; 
GT_flags_ind = 8;

// strings
// GT_uuid_ind = 9;
s1OffS = 10; // notes
conOffS = 11; // contact
// contactIdOffset = 12; // res

idOffset = 14;   //  HARD CODE
p_fixOffset = 10;   //  HARD CODE
UuidOffset = 16;   // last HARD CODED

targetPercent = 80;  // scroll to end
scrolTimeout = 500; // ms
lastVisInd = -1;
infinitScrollCount = 40;
NOscrollTriger = false;

isOnline = 0;
maxMsgSize = 50;
// timezoneOffset = 480;

regxEmail = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
regxNums = new RegExp(/\d+/);
regxPhone = new RegExp(/^1?(\d{10})$/);
regxPhone10 = new RegExp(/^(\d{10})$/);
regxPhone9 = new RegExp(/^1(\d{9})$/);



regxAt = /\@/gi;
regxlb = /\[\(/gi;
regxrb = /\)\]/gi;
regxlcb = /\{/gi;
regxrcb = /\}/gi;
regxStars = /\*/gi;
regxdc = /\"/gi;
regspcc = /\ /gi;
regdspcc = /\ \ /gi;
regcbl = /\</gi;
regcbr = /\>/gi;
regDot = /\./gi;

today;
yesterday;

clickDelayDetailDiv = 5000;  // milisec
searchS = '';
searchData = '';
activeID =  -1;
minMaxs = new Array ();
deviceInfo = '';
paramsG;
stTime = 0;

didSel = '';
didSegSel = '';
selectedSegm = '';
selectedSegmSerch = '';
msgsAllTotal = 0;

askToSave = 'Do You Want To Save?';
urlErrMsg = 'There was a problem, Please Try Again later';
datetime = '';
_err = '';
deleteBadSTentry = 1;
//  reachmeUrl = 'https://web.reachme.com/websrv/';   ///websrv /efs/dev-web/appserver/
reachmeUrl = '/websrv/';   ///websrv /efs/dev-web/appserver/

goRefreshTag = 0;
actionRes = 0;

isDebug = 1;
clickedItemId = '';
scrollP = '';
logInF = new Array();

authIpDebug = '72.134.119.211';  // move to server

refreshTimer = -1;  // -1 = off
timerON = 1;
refreshSecs = 60; 

// ws related
socsMainInd = 0;
socsMind = 0;
webRtcCapable = 0;
unique = Array ();
socs = Array ();
pc = Array()
socState = Array ();
conTimer = 1000;
conTimerOn = 0;
user = '';
callee = ''
ip = '';

hideByClass = 1;
showByClass = -1;

constructor(
  public toastController: ToastController,
  public alert: AlertController,
  private http: HttpClient,
) { 
  // ws related
  this.unique[0] = '';
  this.unique[1] = '';
}


//UTILs
generateGUID() {
  function S4() {return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);}
  return ((S4() + S4()).replace(this.regDot, '-'));
}

getLocalTime (da) {
  try {
  var offset = new Date().getTimezoneOffset();
  var myDate = new Date(da.replace('-', '/').replace('-', '/'));
  myDate.setMinutes(myDate.getMinutes() - offset);
  myDate.setMinutes(myDate.getMinutes() + myDate.getTimezoneOffset());
  return myDate;
  } catch (e) {console.error(e)}
}

async presentToast(msg, color, dur) {
  const toast = await this.toastController.create({
    message: msg,
    color: color,
    cssClass: 'tostSuc',
    duration: dur,
    mode: 'ios',
    keyboardClose: true,
  });
  toast.present();
}
async showAlert(head, subhead, msg) { 
  this.resultRet = '-1';
  const alert = await this.alert.create({ 
    header: head, 
    subHeader: subhead, 
    message: msg, 
    buttons: 
    [
    {text: 'Yes', role: 'Yes', handler: () => {this.resultRet = '1';}}, 
    {text: 'No', role: 'No', handler: () => {this.resultRet = '-1';}}, 
    {text: 'Cancel', role: 'Cancel', handler: () => {this.resultRet = '0';}}
  ]
  }); 
  // beep (1);
  await alert.present(); 
  await alert.onDidDismiss();  
}
async AsyncShowAlert (cap1, cap2) {
  await this.showAlert(cap1, cap2, '').then (res => {return this.resultRet;})
}

// DATETIME      ////$$$
secondsToMinutes(time) { 
  let minutes = '0' + String(Math.floor(time / 60));
  let seconds = '0' + String(time % 60);
  return`${minutes.slice(-2)}:${seconds.slice(-2)}`;
}
setTodayYesturday () {
    this.today = new Date();
    this.yesterday = new Date(Date.now() - 86400000);
}
getTypeLocal (idd) {
    for(let ii = 0; ii < this.msgsTmpls.length; ii++) {
      if (this.msgsTmpls[ii]['id'] == idd) {return this.msgsTmpls[ii]['a'] ;}
    }
    return localStorage.getItem(idd);
}

timerLable (tle, tim) {
  if (tle === null) return;
  let time = this.refreshTimer - tim;
  tle.innerHTML = this.secondsToMinutes(time).substring(3);
}

getID (ind) {return this.ITMS[ind]['a'][this.p_fixOffset] + this.ITMS[ind]['a'][this.idOffset];}

// DID PHONE NUMBER      ////$$$
if_HasSmsDID (user, mustSame) {
  if (this.smsUserAr.length == 0)  return '';
 for (let i = 0; i < this.smsUserAr.length; i++) { if (this.smsUserAr[i] == user) return this.smsUserAr[i];}
 if (mustSame == 1) return '';
 return this.smsUserAr[0];
}

if10dPhone (p) {
  if (p.length < 10) return '';
  if (this.regxPhone9.exec (p)) return '';
  if (this.regxPhone10.exec (p)) return p;
  let pp = this.regxPhone.exec (p);
  if (pp) return pp[1];
  return '';
}







///  cleannnnnnnnnnnnnnnnnnnnnnnnnnnnnn

ifIsPhOrExt(num, formatPH) {
  let p = num.replace(/[^\d]/g, "");
  if (p.length < 7) return p;
  if (p.length < 10) return '';
  if (p[0] == '1') p = p.substring(1);
  let pp = this.if10dPhone (p);
  if ( pp == '') return p;

  if (formatPH == 1) return pp.replace(/^(\d{3})(\d{3})(\d{4})$/, "($1) $2-$3");
  return p;
}
ifIsPh(phone, formatPH, isSMS?) {
  let p = phone.replace(/[^\d]/g, "");
  let pp = this.if10dPhone (p);
  if ( pp == '') return p;
  p = pp;
  if (isSMS == 1) { this.if_HasSmsDID (p, 1); }
  if (formatPH == 1) return p.replace(/^(\d{3})(\d{3})(\d{4})$/, "($1) $2-$3");
  return p;
}




verifySmsSend (to, from, msg) {
  let fromm = this.ifIsPh(from, 0); 
  if (fromm.length != 10) { this.presentToast('Invalid From Number!', 'warning', 1500); return 0; }
  let too = this.ifIsPh(to, 0); 
  if (too.length != 10) { this.presentToast('Invalid To Number!', 'warning', 1500); return 0; }
  if (msg.length == 0 ) { this.presentToast('Invalid Message!', 'warning', 1500); return 0; }
  return 1;
}

// GT ARRAY      ////$$$
setGlobalOffsets (ind: number, v, i) {
  if(v == 'state') this.ITMS[ ind ]['a'][this.GT_state_ind] = i;
  if(v == 'type')  this.ITMS[ ind ]['a'][this.GT_type_ind] = i;
  if(v == 'flags') this.ITMS[ ind ]['a'][this.GT_flags_ind] = i;
}

getAssocMsgArray (ind: number) {
  try {
    let aaa = this.ITMS[ ind ]['a'];
    let state =this.ITMS[ ind ]['a'][this.GT_state_ind];
    let i = this.LStmpl.length;  
    let a = new Array;
    let idd = aaa[ this.LStmpl.length + 2 ] ;
    let aa = this.getTypeLocal(idd);

    if (aa !== null && aa.length > 0) {
      let ar = JSON.parse(aa).splice(this.LStmpl.length) ;
      if (Array.isArray(ar) && ar.length > 0 )  { 
        ar.forEach(v => {if (a[v] === undefined) { 
          a[v] = aaa[i];
          if (state == 0) {this.setGlobalOffsets (ind, v, i);}
        } 
        i++; });
      }
      return a;
    }
  } catch (err) {console.error(err)}
}
insertMsgsTmpls (a, pre) {
  if (pre == '') {return -2;}
  for(let i=0; i< this.msgsTmpls.length; i++) {if (this.msgsTmpls[i]['id'] == pre) return i;}
  let aa = new Array();
  aa['id'] = pre;
  aa['a'] = JSON.stringify(a);
  this.msgsTmpls.push (aa)
  return -1;
}
GO_msgsGTtmp_push (a) {  // verify if dose not exist in localstorage and insert to msgsGTtmp
  if (a === undefined ||a === null || a.length == 0)   return '';
  let keys = [];
  let vals = [];
  try {
    keys = Object.keys(a);
    vals = Object.values(a);
    let isdate  = !isNaN(Date.parse(vals[0]));

    if (keys[0] == '0' &&  isdate === true)   { 
      this.msgsGTtmp_push ( [...this.LStmpl , ...vals], 1, '', 1);  // data  
    }  
    else if (keys[0] == '0' &&  isdate === false) { //   tmpl 
        vals[ 2 ] = this.p_fix;
        this.msgsGTtmp_push ( [...this.LStmplTmpl , ...vals], 1, a[ 2 ], 1);
    }  
    else {   // is associated array  
      this.msgsGTtmp_push ( [...this.LStmplTmpl, ...keys], 1, a[this.p_fix], 1);
      this.msgsGTtmp_push ([ ...this.LStmpl, ...vals], 1, '', 1);
    }
  }
  catch (err) {console.error(err);    }
}
msgsGTtmp_push (a, addLS, pre, chkDup) {
  let aa = new Array(); let ls;
  try {
    aa['id'] = a[this.LStmpl.length + 2] + a[this.LStmpl.length + 1];
    if (chkDup == 1) {
      ls = localStorage.getItem (aa['id']);
      if (ls !== null ) {return;} 
    }
    aa['t'] = '';
    aa['d'] = new Date(a[this.LStmpl.length + 0]).getTime() ;
    aa['a'] = a;
    if (a[this.typeOffS] == 0) {
        a[this.s1OffS] = a[this.LStmpl.length + 2];
        a[this.isVis] = 0;
        a[this.ifItemInSearch] = 1;
        this.msgsGTtmp.push( aa );
        this.getMinmaxs (a);
    } 
    else {
      a[this.s1OffS] = pre;
      this.insertMsgsTmpls (a , pre);
    }
    
    if (addLS == 1) { 
      if (a[this.typeOffS] == 0) { pre = aa['id'];} 
      else if (a[this.typeOffS] == 1) {
        if (pre == '') {pre =a[this.LStmpl.length + 2] ;}
        this.insertMsgsTmpls (a, pre);
      } 
      localStorage.setItem(pre, JSON.stringify(a)); 
    }
    
  } catch (err) {console.error(err); return}
}
getMinmaxs (a) {
  //`${key}: ${local  --  Storage. get Item(key)}`;
  try {
  let m = a[this.LStmpl.length + 1];
  let key = a[ this.LStmpl.length + 2 ] ;
  if (key !== undefined) {
    if (this.minMaxs [ key + 'min'] === undefined) this.minMaxs [ key + 'min'] = m; 
    if (this.minMaxs [ key + 'max'] === undefined) this.minMaxs [ key + 'max'] = m; 
    if (this.minMaxs [ key + 'min'] > m) {this.minMaxs [ key + 'min'] = m; } // } 
    if (this.minMaxs [ key + 'max'] < m) {this.minMaxs [ key + 'max'] = m; } // }
  }
  else {console.error( a)}
} catch (err) {console.error(err)}
}

parse_retData (retData) {
  const allusers = retData['_all_users'];
  console.log(retData)
  const sms_users_array = retData['_users'];
  const user_data = retData['_user_data'];
  const data = retData['_data'];

  this.suuid = retData['suuid'] !== undefined ? retData['suuid'] : '';
  this. datetime = retData['_datetime'] !== undefined ?  retData['_datetime'] : '';
  this. customRuts = retData['_blks'] !== undefined ?  retData['_blks'] : '';
  this. refrence = retData['refrence'] !== undefined ?  retData['refrence'] : '';
  if ( retData['_err'] !== undefined) { for (let i = 0; i < retData['_err'].length ; i++) {console.log(retData['_err'][i]);} }

  if (this.rpsw == '' && this.suuid != '' ) this.rpsw = this.suuid;

  if (allusers !== undefined ) { this.getAlluserArr (allusers); }
  if (sms_users_array !== undefined ) { this.getSmsUserArr (sms_users_array); }
  if (user_data !== undefined ) { this.getUserArr (user_data); }
  if (data !== undefined ) { this.getDataArr (data); }
}

removeDupITMS (idd) {
  let i = 0;
  for(i = 0; i < this.ITMS.length ; i++) {
    if (this.getID (i) == idd) {
      this.ITMS.splice(i, 1);
       localStorage.removeItem(idd); 
      return;
    }
  }
}
findDupUuid (ii, aa) {

  // do only on new items comming later dddddddddddddddd

  let i = 0; let ai; let aii;
  for(i = 0; i < this.ITMS.length ; i++) {
    if (ii == i) continue;
    if (this.ITMS[i]['a'][this.UuidOffset] != this.ITMS[ii]['a'][this.UuidOffset]) continue;

    ai = this.getAssocMsgArray (i); 
    aii = this.getAssocMsgArray (ii); 

    if (ai['dest'] == aii['dest'] && ai['from'] == aii['from']) {
      aa.push(this.getID (ii));
    }

  }
}
removeDupReports () {
  if (this.ITMS.length == 0) return;
  let aa = new Array();  let ii = 0;
  for(ii = 0; ii < this.ITMS.length ; ii++) {
    if (this.ITMS[ii]['a'][this.p_fixOffset] == 'r_') {
      this.findDupUuid (ii, aa);
    }
  }
  if (aa.length == 0) return;
  for(ii = 0; ii < aa.length ; ii++) {this.removeDupITMS (aa[ii]);}
}

countHis (gID) {
  let c = 0;
  let ind = this.findInd (gID); if (ind == -1) return;
  let user = this.ITMS[ind]['a'][this.conOffS].toLowerCase();
  for(let ii = 0; ii < this.ITMS.length; ii++){
      if (ii != ind) {
      if (this.ITMS[ii]['a'][this.conOffS].toLowerCase().indexOf(user) > -1) c++;
      }
  }
  return c;
}

getDataArr (data) {
  if (data.length == 0) return;
  for(let i=0; i<data.length; i++) {
    this.GO_msgsGTtmp_push(data[i]); 
  }
}

getAlluserArr (allusers) {
  if (allusers.length == 0) return;
  this.allUsersA = new Array(); 

  let s = '';
  for(let i=0; i< allusers.length; i++) {
    s = allusers[i] ;
    if (s.indexOf('.') > -1 ) this.sipStasions.push (s.substring(0, s.indexOf('.'))); 
    else this.allUsersA.push (s);

  }
  console.log(this.sipStasions);
}
getUserArr (user_data) {
  if (user_data.length == 0) return;
  this.user_dataA = new Array(); 
    for(let i=0; i< user_data.length; i++) {this.user_dataA.push (user_data[i]);}
}

getSmsUserArr (sms_users_array) {
  if (sms_users_array.length == 0) return;
  this.smsUserAr = new Array(); 
  for(let i=0; i< sms_users_array.length; i++) {this.smsUserAr.push (sms_users_array[i]);}
}

findInItems_uuid (uuid) {
let ii = 0;
  for( ii = 0; ii < this.ITMS.length ; ii++) {
    if (this.ITMS[ii]['a'][this.UuidOffset] != '' && this.ITMS[ii]['a'][this.UuidOffset] == uuid) {
        return this.getID (ii);
    }
  }
return '';
}

findInd (gID) {
  let i = 0;
  for(i = 0; i < this.ITMS.length ; i++) {
    if (this.getID (i) == gID) return i;
  }
  console.error(gID + ' NOT FOUND');
  return -1;
}

addToGroupArray (cap, ico) {
  let ad = this.GS_tmpl;
  ad[this.GS_cap_offset] = cap;
  ad[this.GS_icon_offset] = ico;
  ad[this.GS_se_total_offset] = 0;
  ad[this.GS_total_offset] = 0;
  let add = [Object.values(ad)];
  this.GS = this.GS.concat(add);
  // localStorage.setItem ('gs', JSON.stringify(this.GS));
}
getTags() {
  let a;
  for(let ii=this.ITMS.length - 1; ii >= 0; ii--) {
    a =  this.getAssocMsgArray (ii);
    this.ITMS[ii]['t'] = this.getTag ( a, this.ITMS[ii]  );
    this.getBlks (this.ITMS[ii]);
  }
}
getFormatTags (format) {
  let tag = '';
  switch (format) {
    case this.MSGS_FORMAT_WAV : 
    case this.MSGS_FORMAT_MP3 : { tag += '@Audio';  break;} 
    case this.MSGS_FORMAT_TXT : { tag += '@Text';   break; } 
    case this.MSGS_FORMAT_TIF: 
    case this.MSGS_FORMAT_PDF: 
    case this.MSGS_FORMAT_TIF_PDF : { tag += '@Pdf';  break;} 
    default: break;
  }
  return tag;
}
getTag (a, aa) {
  let tag = '';

  if (a['p_fix'] == 'm_') {
    aa['a'][this.readOffS] = 0; 
    tag += this.getFormatTags (a['format']);

    if (a['flags'] & this.MSGS_FLAGS_FLAGGED) {tag += '@Flg';}

    switch (a['type']) {
      case this.MSGS_TYPE_SENT :             tag += '@Sent'; break;
      case this.MSGS_TYPE_OUT_PSTN_CONV_REC: tag += '@DialR'; break;
      case this.MSGS_TYPE_IN_PSTN_CONV_REC:  tag += '@InRec'; break; 

      case this.MSGS_TYPE_VOICEMAIL:
        switch (a['state']) {
        case this.MSGS_STATE_DELETED: { tag += '@Bin'; break; }
        case this.MSGS_STATE_UNREAD : { tag += '@New';  break;}
        case this.MSGS_STATE_READ : { tag += '@Read';  break;}
        default: break;
        }
        break;
      
      default: break;
    }

  }
  else if (a['p_fix'] == 'r_') {
    aa['a'][this.readOffS] = 1; 
    switch(a['type'])  {
      case this.CDRS_TYPE_PSTN_IN :  tag += '@Mis'; break;
      case this.CDRS_TYPE_PSTN_OUT : tag += '@Dials'; break;
      case this.CDRS_TYPE_FAX_IN :  tag += '@Fax'; break; 
      default: break;
    }
  }
  aa['a'][this.conOffS] = a['from']; 
  if ((aa['a'][this.readOffS] == 0 && a['type'] == this.MSGS_TYPE_SENT)
    || (aa['a'][this.readOffS] == 0 && a['type'] == this.MSGS_TYPE_OUT_PSTN_CONV_REC)
    || (aa['a'][this.readOffS] == 1 && a['type'] == this.CDRS_TYPE_PSTN_OUT)
  ) aa['a'][this.conOffS] = a['dest'];

  return tag;
}

getAddGS ( cap, ico, add) {
  for (let ii = 0; ii < this.GS.length; ii++) {
      if (this.GS[ii][this.GS_cap_offset] == cap) {
          if (ico == '_') this.GS[ii][this.GS_icon_offset] = '';
          else if (ico != '') this.GS[ii][this.GS_icon_offset] = ico;
          return ii;
      }
  }
  if (add == 1) { 
      this.addToGroupArray (cap, ico);    
      return this.GS.length - 1; 
  }
  return -1
}
resetGScounts () {
  let iii = 0;   let tags = [];
  this.msgsAllTotal = 0;
  for (let i = 0; i < this.GS.length; i++) {
      this.GS[i][this.GS_total_offset] = 0;
      this.GS[i][this.GS_se_total_offset] = 0;
  }
  for(let ii=this.ITMS.length - 1; ii >= 0; ii--) {
      if (this.ITMS[ii]['a'][this.ifItemInSearch] == 0) continue;

      // notDel = this.ITMS[ii]['a'][this.ITMS[ ii ]['a'][this.GT_state_ind]] == this.MSGS_STATE_DELETED ? false : true;
      // notDel = this.ITMS[ii]['a'][this.GT_state_ind] == this.MSGS_STATE_DELETED ? false : true;
      // notDel = true;

      // if (notDel) {
      ++this.msgsAllTotal;
      // All has to be the first
      ++this.GS[0][this.GS_total_offset];
      ++this.GS[0][this.GS_se_total_offset];
      // }
      
      tags = this.ITMS[ii]['t'].split('@');
      for (let i = 0; i < tags.length; i++) {
      if (tags[i] == '') continue;
      iii = this.getAddGS (tags[i], '', 1);
      // if (notDel) {
          ++this.GS[iii][this.GS_total_offset];
          ++this.GS[iii][this.GS_se_total_offset];
      // }
      }
  }
}

remTag (ind: number, regx,  tag) {
  if ((this.ITMS[ind]['t'] + '@').indexOf('@'+tag + '@') == -1) {return;}
  this.ITMS[ind]['t'] = this.ITMS[ind]['t'].replace (regx, '');
}
addTag (ind: number, tag) { this.ITMS[ind]['t'] += '@' + tag; }
setItemTagField (ind: number, act) {
  switch (act) {
  case 'read': case'red': case 'redall': case 'udel': case 'udelall':
    this.remTag(ind, /@New/gi, 'New');
    this.remTag(ind, /@Bin/gi, 'Bin');
    this.addTag(ind, 'Read');
    break;
  case 'del': case 'delall':
    this.remTag(ind, /@New/gi, 'New');
    this.remTag(ind, /@Read/gi, 'Read');
    this.addTag(ind, 'Bin');
    break;
  case 'ured': case 'uredall':
    this.remTag(ind, /@Bin/gi, 'Bin');
    this.remTag(ind, /@Read/gi, 'Read');
    this.addTag(ind, 'New');
    break;

    case 'flg': case 'flgall': this.addTag(ind, 'Flg'); break;
    case 'uflg': case 'uflgall': this.remTag(ind, /@Flg/gi, 'Flg'); break;
  default: break;
  }
}
updateMsgGT (actID, ind: number) {
  try {
  const a = this.getAssocMsgArray (ind);
  switch (actID) {
    case 'udel': case 'udelall': 
    case 'redall': case 'red':   this.ITMS[ind]['a'][this.ITMS[ ind ]['a'][this.GT_state_ind]] = this.MSGS_STATE_READ; break;
    case 'del': case 'delall':   this.ITMS[ind]['a'][this.ITMS[ ind ]['a'][this.GT_state_ind]] = this.MSGS_STATE_DELETED; break;
    case 'uflg': case 'uflgall': this.ITMS[ind]['a'][this.ITMS[ ind ]['a'][this.GT_flags_ind]] &= ~this.MSGS_FLAGS_FLAGGED; break;
    case 'flg': case 'flgall':   this.ITMS[ind]['a'][this.ITMS[ ind ]['a'][this.GT_flags_ind]] |= this.MSGS_FLAGS_FLAGGED; break;
    case 'uredall': case 'ured': this.ITMS[ind]['a'][this.ITMS[ ind ]['a'][this.GT_state_ind]] = this.MSGS_STATE_UNREAD; break;

    case 'blk':   this.ITMS[ind]['a'][this.flags1_offset] |= this.PROFILE_FLAG_BLOCKED; break;
    case 'ublk':   this.ITMS[ind]['a'][this.flags1_offset] &= ~this.PROFILE_FLAG_BLOCKED; break;

    case 'pugall' : this.ITMS.splice(ind, 1); localStorage.removeItem(this.ITMS[ind]['id']); return;

    default: console.error ("Not found " + actID + ' < ' + ind); return;
  }

  this.setItemTagField (ind, actID) ;
  this.setLStorageItem(ind);
  } catch(err){console.error(err)}
}

getBlks (aa) {
  if (this.customRuts.length == 0) return;
  for(let i= 0; i < this.customRuts.length; i++) {
    if (this.customRuts[i][1] == '1' && this.customRuts[i][3] == '10' 
      && this.customRuts[i][0] == aa['a'][this.conOffS]) {
        aa['a'][this.flags1_offset] |= this.PROFILE_FLAG_BLOCKED;
        return;
      }
  }
}

updateBlksRuts (contact) {
  let cri = -1; let blk = 0;
  for(let i= 0; i < this.customRuts.length; i++) {
    if (this.customRuts[i][0] == contact) {cri = i;  break;}
  }
  if (blk == 1) {
    if (cri == -1) {
      let aa = [contact, '1', '', '10', '', ''];
      this.customRuts.push (aa);
    }
    else {
        this.customRuts[cri][1] = '1';
        this.customRuts[cri][3] = '10';
    }
    return;
  }
  if (cri > -1) { this.customRuts[cri][1] = '0'; }
}

setConsNams (ind: number, name) {
  let user = this.ITMS[ind]['a'][this.conOffS];
  for(let ii = 0; ii < this.ITMS.length; ii++){
    if (this.ITMS[ii]['a'][this.conOffS] == user) {
      let i = this.getIndexA (this.ITMS[ii]['a'], 'cname');
      if (i > -1 ) {this.ITMS[ii]['a'][i] = name;}
    }
  }
}
getIndexA (aaa, key) {
    let i = this.LStmpl.length;  
    let ii = -1;  
    let idd = aaa[ this.LStmpl.length + 2 ] ;
    let aa = this.getTypeLocal(idd);
    if (aa !== null && aa.length > 0) {
      let ar = JSON.parse(aa).splice(this.LStmpl.length) ;
      if (Array.isArray(ar) && ar.length > 0 )  { ar.forEach (v => { if (v == key)  {ii = i;} i++; }); }
    }
    return ii;
}

// LOCALSTORAGE      ////$$$
set_LS (id, v) { 
  localStorage.setItem (id, v); 
}
get_LS (id) { let s = localStorage.getItem(id);  if (s !== null) return s; return ''; }
getLSitem (key) {
  let a = []; let s = '';
  try {
    s = localStorage.getItem(key);
    // if (key == 'gs') return a;
    if (key == 'params') return a;
    if (key == '_capuid') return a;
    if (s.slice(-1) != ']' ) return a;
    if (s.slice(0, 1) != '[' ) return a;
    return JSON.parse(s);
  } catch (err) { console.error(s + ' ????????? ' + key + ' ? '+ err ); }
  return a;
}
setLStorageItem (ind: number) {
  try {localStorage.setItem(this.ITMS[ind]['id'], JSON.stringify(this.ITMS[ind]['a']));}catch(err){console.error(err)}
}
localstorage_set () {
  try {
  let s = '[';
  Object.keys (this.minMaxs).forEach ( k => {s = s + k + ':' + this.minMaxs[k] + ',';})
  s += ']';
  s = s.replace(',]', ']');
  if (s != '[]') { localStorage.setItem('params',  s );}
} catch (err) {console.error(err)}
}
localstorage_set_rpsw (retData) {
  try {
  if (this.remv == false) { this.logout (0); }
  else  {
    this.rpsw = retData['rpsw'] !== undefined ? retData['rpsw'] : '';
    if (this.rpsw != '') {localStorage.setItem ('rpsw', this.rpsw);}
  }
  } catch (err) {console.error(err)}
}
loopLStoreage () {
  let a = [];
  this.msgsGTlocalStoreArr = new Array ();
  for(let i=0; i<localStorage.length; i++) {
    try {
      a = this.getLSitem( localStorage.key(i) );
      if (Array.isArray(a) && a.length > 0) { this.msgsGTlocalStoreArr.push (a); }
    } catch (err) {console.error(err);}
  }
}

// URL POST      ////$$$

getMsgsMinMaxParams (postData) {
  this.paramsG = localStorage.getItem('params');
  if (this.paramsG !== null)  postData['params'] = this.paramsG;
}

getAction_Postdata (actid, ind: number, actData: string, refrence) {
  let a = this.getAssocMsgArray (ind);
  let postData = {
    "actID": actid,
    "actData": actData,
    "refrence": refrence,
    "msgUuid": a['uuid'],
    "cuid": a['custID'],
  }
  return postData ;
}
sms_Postdata (postData, from, to, msg, actID) {
  postData['smsfrom'] = from;
  postData['smsto'] = to;
  postData['message'] = msg;
  postData['actID'] = actID;
  this.actionRes = 1;
  return postData ;
}
getMsgs_Postdata () {
  let postData = {
    "actID": 'login',
    "username": this.username,
    // "remv": this.remv, 
    "upsw": this.upsw,
    "path": this.path,
    "deviceInfo": this.deviceInfo,
  }

  this.getMsgsMinMaxParams (postData) ;
  console.log (postData); 
  return postData;
}
goRefresh_Postdata (mg) { 
  let postData = {
    "actID": 'refresh',
    "subID": mg,
  }
  this.getMsgsMinMaxParams (postData) ;
  return postData;
}

postdataDefaults (postData){
  postData['username'] = this.username;
  postData['rpsw'] = this.rpsw;
  postData['duuid'] = this.duuid;
  postData['suuid'] = this.suuid;
  postData['url_prefix'] = this.url_prefix;
  return postData;
}

DID_Postdata (actData, sub_ID) {
  let postData = {}; 
  postData['bg'] = this.bg;
  postData['did'] = this.didSel;
  postData['actID'] = 'dids';
  postData['subID'] = sub_ID;
  postData['actData'] = actData;
  return postData;
}

postUrl (url, postData: any): Observable<any> {
  this.postdataDefaults (postData);
  const headers = new HttpHeaders().set("Access-Control-Allow-Origin", "*");
  headers.set('Content-Type', 'application/json');  // jsx
  headers.set('Access-Control-Allow-Methods', 'PUT, GET, POST, DELETE, OPTIONS');
  headers.set('Access-Control-Allow-Headers', 'authorization, origin, user-token, x-requested-with, content-type');
 try{
  return this.http.post(url, postData, {headers}).pipe(map(results => results)); // results['Search']
  } catch (err) { console.error(err); return err; }
}

logout (relod: number) {
  this.rpsw = '';
  localStorage.removeItem ('rpsw');
  if (relod == 1) window.location.reload();
}

getICON () {
  return  { "id": '', "name": '', "color": 'dark', "class": '' }
}







  // async presentLoading() {
  //   let loading = await this.loadingController.create({
  //     // message: 'Please wait...',
  //     duration: this.gs.scrolTimeout,
  //   });
  //   await loading.present();

  //   let { role, data } = await loading.onDidDismiss();
  //   this.gs.NOscrollTriger = false;
  // }

// addBodyClass( classToAdd: string ): void {this.renderer.addClass( document.body, classToAdd );}
// removeBodyClass( classToRemove: string ): void {this.renderer.removeClass( document, classToRemove );}

    // addBodyClass( classToAdd: string ): void {this.renderer.addClass( document.body, classToAdd );}
    // removeBodyClass( classToRemove: string ): void {this.renderer.removeClass( document, classToRemove );}
    
// import { addListener } from 'process';
// import { SocketIO } from '../services/io.service';

// import { Ws } from '../services/ws.service';
// //  import * as Recorder  from './recorder.js';
// import * as WavCan from './script-mp3.js';
// import { ModalController } from '@ionic/angular';

// import { IonInfiniteScroll } from '@ionic/angular';
// import { Track } from 'ngx-audio-player';  
// import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
// import { DocumentViewer } from '@ionic-native/document-viewer/ngx';
// import { Contacts, Contact, ContactField, ContactName } from '@ionic-native/contacts';
// import { CallNumber } from '@ionic-native/call-number';
 // goClear () {
  //     this.showAlert('Clear Local Storage ?', 'It will Delete all Not Saved Data', '').then (res => {
  //       if (this.resultRet == '1') {
  //         localStorage.clear();
  //         window.location.reload ();
  //       }
  //     })
  //   }
  // }

 // async removeItem(key: string) {await Storage.remove({ key });}
  // async clear() {await Storage.clear();}
  // insertBe(ee, e) {ee.parentNode.insertBefore(e, ee.nextSibling);}
  // location.reload(true);   hard reload and clear cashe

  // getOrient () {
  //   window.addEventListener('orientationchange', function () {
  //     var ev = window.innerWidth;
  //     var e = (document.getElementById('s1') as HTMLInputElement); e.innerHTML = ev.toString();
  //     var h = window.innerHeight;
  //     e = (document.getElementById('s2') as HTMLInputElement); e.innerHTML = h.toString();
  //     var ang = screen.orientation.angle;
  //     e = (document.getElementById('s3') as HTMLInputElement); e.innerHTML = ang.toString();
  //     console.log(screen.orientation.angle);
  //   });
  // }

  // private hapticsImpactMedium = async () => {  await Haptics.impact({ style: ImpactStyle.Medium });};
  // private hapticsImpactLight = async () => {  await Haptics.impact({ style: ImpactStyle.Light });};
  // private hapticsVibrate = async () => {  await Haptics.vibrate();};
  // private hapticsSelectionStart = async () => {  await Haptics.selectionStart();};
  // private hapticsSelectionChanged = async () => {  await Haptics.selectionChanged();};
  // private hapticsSelectionEnd = async () => {  await Haptics.selectionEnd();};

   // getUrl (url: string): Observable<any> {
  //   const headers = new HttpHeaders().set("Access-Control-Allow-Origin", "*");
  //   headers.set('Content-Type', 'application/x-www-form-urlencoded');
  //   headers.set('Access-Control-Allow-Methods', 'PUT, GET, POST, DELETE, OPTIONS');
  //   headers.set('Access-Control-Allow-Headers', 'authorization, origin, user-token, x-requested-with, content-type');
  //   return this.http.get(url, {headers}).pipe(map(results => results)); // results['Search']
  //   //.subscribe(results => {this.aResult = JSON.stringify(results);
  //   // return this.http.get(`${this.url}?s=${encodeURI(title)}&type=${type}&apikey=${this.apiKey}`)
  // }

  // async setString(key: string, value: string) {await Storage.set({ key, value });}
  // async getString(key: string): Promise<{ value: any }> {return (await Storage.get({ key }));}
  // async setObject(key: string, value: any) {await Storage.set({ key, value: JSON.stringify(value) });}
  // async getObject(key: string): Promise<{ value: any }> {const ret = await Storage.get({ key }); return JSON.parse(ret.value);}
 
   // string sort  good aa.sort((a, b) => { if (a['id']  < b['id'] ) { return -1; } if (a['id']  > b['id'] ) { return 1; } return 0; });
   
  // uuid = function(a,b){for(b=a='';a++<36;b+=a*51&52?(a^15?8^Math.random()*(a^20?16:4):4).toString(16):'-');return b};;
  // ifDoitWithDelay (ms, _ifZero) {  var ifDoit =  new Promise(resolve => setTimeout(resolve, ms));}

// startt () { this.util.getRec(); this.util.guiIni(); }
  //  ASORT = Array.prototype.sort((a: any, b: any) => (+new Date(b.datetime) - +new Date(a.datetime)));
  //  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  // @ViewChild('imageCanvas') canvas: any;
  // canvasElement: any;
  // window: Window;

  // import { Ws } from '../services/ws.service';
// import { Vibration } from '@ionic-native/vibration/ngx';
// import { Haptics, ImpactStyle } from '@capacitor/haptics';
// import { MediaPlugin } from '@ionic-native/media';
// import { File } from '@ionic-native/file';
}
